import { PmhcEditor } from './__pmhc-suggestion-editor'

export { action } from './__pmhc-suggestion-editor.server'

export default function NewPMHCRoute() {
	return (
		<main className="container flex flex-col justify-center pb-32 pt-10">
			<h1 className="mb-4 text-h2">Suggest a new PMHC</h1>
			<PmhcEditor />
		</main>
	)
}
